// Mock data for Next Generation Tree Service & Landscaping LLC

export const companyInfo = {
  name: "Next Generation Tree Service & Landscaping LLC",
  tagline: "Next-Level Tree Care & Landscaping You Can Trust",
  phone: "(615) 944-9032",
  phoneSecondary: "(615) 310-4173",
  hours: "Open 24 hours",
  location: "Nashville, Tennessee",
  rating: 5.0,
  totalReviews: 2
};

export const services = [
  {
    id: 1,
    title: "Tree Removal",
    description: "Complete tree removal services including crane removals for large or hazardous trees",
    icon: "Axe"
  },
  {
    id: 2,
    title: "Tree Trimming & Pruning",
    description: "Professional trimming and pruning to maintain tree health and aesthetics",
    icon: "Scissors"
  },
  {
    id: 3,
    title: "Emergency Tree Services",
    description: "24/7 emergency response for storm damage and hazardous tree situations",
    icon: "AlertCircle"
  },
  {
    id: 4,
    title: "Technical Removals",
    description: "Specialized technical removals for challenging locations and situations",
    icon: "Wrench"
  },
  {
    id: 5,
    title: "Stump Grinding",
    description: "Complete stump removal and grinding services to reclaim your yard space",
    icon: "Circle"
  },
  {
    id: 6,
    title: "Landscaping Services",
    description: "Full-service landscaping to transform your outdoor spaces",
    icon: "Leaf"
  },
  {
    id: 7,
    title: "Arbor Care & Maintenance",
    description: "Ongoing tree health care and maintenance programs",
    icon: "HeartPulse"
  },
  {
    id: 8,
    title: "Lawn Care & Grass Cutting",
    description: "Professional lawn mowing, edging, and grass maintenance services",
    icon: "Sparkles"
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "Licensed, Insured & Bonded",
    description: "Fully licensed and insured for your protection and peace of mind",
    icon: "Shield"
  },
  {
    id: 2,
    title: "Certified Climbers",
    description: "All our climbers use proper PPE and follow strict safety protocols",
    icon: "Award"
  },
  {
    id: 3,
    title: "State-of-the-Art Equipment",
    description: "Latest technology and equipment for efficient, safe operations",
    icon: "Truck"
  },
  {
    id: 4,
    title: "Ground Protection",
    description: "We use protection mats to preserve your property during work",
    icon: "ShieldCheck"
  },
  {
    id: 5,
    title: "Fast Emergency Response",
    description: "Available 24/7 for emergency tree services when you need us most",
    icon: "Zap"
  },
  {
    id: 6,
    title: "Free Estimates",
    description: "Get a detailed, no-obligation estimate for your project",
    icon: "FileText"
  }
];

export const reviews = [
  {
    id: 1,
    name: "Lisa Bartok Jordan",
    rating: 5,
    date: "3 hours ago",
    text: "I've been using NextGeneration Landscape for over 3 years. They are incredibly reliable, dependable, professional, and always do an excellent job. Highly recommend their services!",
    avatar: "LJ"
  },
  {
    id: 2,
    name: "Scott Bartock",
    rating: 5,
    date: "3 hours ago",
    text: "The Nice Gen team cleared 8 og trees from our yard including some storm damaged trees. They were very knowledgeable and professional. Great service!",
    avatar: "SB"
  }
];

export const galleryImages = [
  // ALL YOUR ACTUAL WORK PHOTOS - Mixed throughout for variety
  {
    id: 1,
    url: "https://customer-assets.emergentagent.com/job_premium-arborcare/artifacts/rnsjti9v_IMG_0394.HEIC",
    title: "Professional Tree Work",
    category: "Tree Service"
  },
  {
    id: 2,
    url: "https://customer-assets.emergentagent.com/job_premium-arborcare/artifacts/7luhgpzc_IMG_0956.HEIC",
    title: "Crane Tree Removal",
    category: "Tree Service"
  },
  {
    id: 3,
    url: "https://customer-assets.emergentagent.com/job_premium-arborcare/artifacts/yqhpt1fe_IMG_0653.HEIC",
    title: "Tree Service Project",
    category: "Tree Service"
  },
  {
    id: 4,
    url: "https://customer-assets.emergentagent.com/job_premium-arborcare/artifacts/tx7dut9h_IMG_0958.HEIC",
    title: "Expert Tree Removal",
    category: "Tree Service"
  },
  {
    id: 5,
    url: "https://customer-assets.emergentagent.com/job_premium-arborcare/artifacts/nsz5wsg8_IMG_0838-preview.HEIC",
    title: "Quality Tree Care",
    category: "Tree Maintenance"
  },
  {
    id: 6,
    url: "https://customer-assets.emergentagent.com/job_premium-arborcare/artifacts/4hwprqaf_IMG_0960-preview.HEIC",
    title: "Professional Tree Service",
    category: "Tree Service"
  },
  {
    id: 7,
    url: "https://customer-assets.emergentagent.com/job_premium-arborcare/artifacts/167un03h_IMG_0842-preview.HEIC",
    title: "Expert Tree Service",
    category: "Tree Service"
  },
  {
    id: 8,
    url: "https://customer-assets.emergentagent.com/job_premium-arborcare/artifacts/xkvqdzc5_IMG_7950.HEIC",
    title: "Tree Trimming Project",
    category: "Tree Maintenance"
  },
  {
    id: 9,
    url: "https://customer-assets.emergentagent.com/job_premium-arborcare/artifacts/4g7xlieq_IMG_0930-preview.HEIC",
    title: "Professional Results",
    category: "Tree Service"
  },
  {
    id: 10,
    url: "https://customer-assets.emergentagent.com/job_premium-arborcare/artifacts/7p6whoqc_IMG_1120.jpg",
    title: "Completed Tree Work",
    category: "Tree Service"
  },
  {
    id: 11,
    url: "https://customer-assets.emergentagent.com/job_premium-arborcare/artifacts/hdglgprj_IMG_0932-preview.HEIC",
    title: "Tree Removal Project",
    category: "Tree Service"
  },
  {
    id: 12,
    url: "https://customer-assets.emergentagent.com/job_premium-arborcare/artifacts/40zxxa4k_IMG_0933-preview.HEIC",
    title: "Professional Tree Care",
    category: "Tree Maintenance"
  },
  {
    id: 13,
    url: "https://customer-assets.emergentagent.com/job_premium-arborcare/artifacts/i8czwgte_IMG_0934-preview.HEIC",
    title: "Expert Tree Work",
    category: "Tree Service"
  },
  {
    id: 14,
    url: "https://customer-assets.emergentagent.com/job_premium-arborcare/artifacts/085o4rvy_IMG_0935-preview.HEIC",
    title: "Tree Service Excellence",
    category: "Tree Service"
  },
  {
    id: 15,
    url: "https://customer-assets.emergentagent.com/job_premium-arborcare/artifacts/6k5morag_IMG_0954.HEIC",
    title: "Completed Tree Project",
    category: "Tree Service"
  }
];

export const serviceAreas = [
  "Nashville",
  "Brentwood",
  "Franklin",
  "Hendersonville",
  "Mt. Juliet",
  "Murfreesboro",
  "Smyrna",
  "Goodlettsville"
];

export const bookingTimeSlots = [
  "8:00 AM - 10:00 AM",
  "10:00 AM - 12:00 PM",
  "12:00 PM - 2:00 PM",
  "2:00 PM - 4:00 PM",
  "4:00 PM - 6:00 PM",
  "Emergency Service (24/7)"
];
